<div class="department-page">
  <div class="department-header">
    <app-header-style-seven></app-header-style-seven>
  </div>

  <div class="custom-container">
    <section class="dept-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Management Department</span>
          <h1>{{ departmentName }}</h1>
          <p>
            Developing future-ready management professionals through value-based education,
            leadership formation, entrepreneurship, industry engagement, and inclusive learning.
          </p>
        </div>

        <div class="hero-stats">
          <div class="stat-card">
            <span class="stat-label">Established</span>
            <strong>{{ establishedYear }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Affiliation</span>
            <strong>Anna University</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Programme</span>
            <strong>{{ programmeSummary }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Contact</span>
            <strong>{{ contactEmail }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="department-shell">
      <aside class="department-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Department Menu</span>
          <h2>{{ departmentName }}</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="department-main">
        <section class="content-head-card">
          <span class="content-tag">Academic Profile</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Department of Master of Business Administration, Fatima Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- About -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/page-title10.jpeg"
                  alt="Department of Master of Business Administration"
                />
              </div>

              <div class="section-copy">
                <h3>About the Department</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="fact-grid">
              <article class="fact-card" *ngFor="let fact of quickFacts">
                <span class="fact-title">{{ fact.title }}</span>
                <p>{{ fact.value }}</p>
              </article>
            </section>
          </ng-container>

          <!-- Vision & Mission -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="info-grid">
              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/vision-icon.png" alt="Vision" />
                </div>
                <h3>Our Vision</h3>
                <p>{{ visionText }}</p>
              </article>

              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/mission-icon.png" alt="Mission" />
                </div>
                <h3>Our Mission</h3>
                <div class="stack-list">
                  <p *ngFor="let item of missionPoints">
                    {{ item }}
                  </p>
                </div>
              </article>
            </section>
          </ng-container>

          <!-- PEO -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Educational Objectives (PEO)</h3>
                <p>Broad career and professional outcomes expected from the programme.</p>
              </div>

              <div class="numbered-list">
                <article class="number-card" *ngFor="let peo of peos; let i = index">
                  <div class="number-badge">{{ i + 1 }}</div>
                  <p>{{ peo }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- POs & PSOs -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Outcomes (POs)</h3>
                <p>Programme outcomes designed to shape professional, ethical, and managerial competence.</p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Program Specific Outcomes (PSOs)</h3>
                <p>Department-specific competencies developed through the MBA programme.</p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programSpecificOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Programme Offered -->
       <!-- Programme Offered -->
<ng-container *ngSwitchCase="'tab14'">
  <section class="content-card">
    <div class="section-head">
      <h3>Programme Offered</h3>
      <p>Current academic programme details under the department.</p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Programme Name</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let programme of programmes">
            <td>{{ programme.sno }}</td>
            <td>{{ programme.name }}</td>
            <td>{{ programme.duration }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="section-head" style="margin-top: 24px;">
      <h3>Specializations Offered</h3>
      <p>Specialization areas available under the MBA programme.</p>
    </div>

    <div class="numbered-list">
      <article class="number-card" *ngFor="let item of specializationsOffered">
        <div class="number-badge">{{ item.sno }}</div>
        <p>{{ item.name }}</p>
      </article>
    </div>
  </section>
</ng-container>
          <!-- Laboratory Facilities -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Laboratory Facilities</h3>
                <p>Laboratory facility details will be updated soon.</p>
              </div>
            </section>
          </ng-container>

          <!-- Association Activities -->
       <!-- Association Activities -->
<ng-container *ngSwitchCase="'tab6'">
  <section class="content-card">
    <div class="section-head">
      <h3>Association Activities</h3>
      <p>Entrepreneurship Development Cell activities conducted for student enrichment, entrepreneurial awareness, and industry readiness.</p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name of the Activity</th>
            <th>Resource Person</th>
            <th>Outcome</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of associationActivities">
            <td>{{ item.sno }}</td>
            <td>{{ item.activity }}</td>
            <td>{{ item.resourcePerson }}</td>
            <td>{{ item.outcome }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

        <!-- MoUs -->
<ng-container *ngSwitchCase="'tab7'">
  <section class="content-card">
    <div class="section-head">
      <h3>MoU's</h3>
      <p>Memorandums of Understanding established for academic enrichment, industry exposure, and student development.</p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name of the Activity</th>
            <th>Organization</th>
            <th>Outcome</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of mous">
            <td>{{ item.sno }}</td>
            <td>{{ item.activity }}</td>
            <td>{{ item.organization }}</td>
            <td>{{ item.outcome }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

          <!-- Placement Record -->
          <ng-container *ngSwitchCase="'tab8'">
            <section class="content-card">
              <div class="section-head">
                <h3>Placement Record</h3>
                <p>Placement details will be updated soon.</p>
              </div>
            </section>
          </ng-container>

          
<!-- Industrial Visit -->
<ng-container *ngSwitchCase="'tab9'">
  <section class="content-card">
    <div class="section-head">
      <h3>Industrial Visit</h3>
      <p>Industrial visits organized to provide practical exposure and industry-oriented learning for MBA students.</p>
    </div>

    <div class="table-wrap">
      <table class="info-table industrial-visit-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Photo</th>
            <th>Visit Title</th>
            <th>Date</th>
            <th>Place</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let visit of industrialVisits">
            <td>{{ visit.sno }}</td>
            <td>
              <div class="iv-photo">
                <img [src]="visit.image" [alt]="visit.title" />
              </div>
            </td>
            <td>{{ visit.title }}</td>
            <td>{{ visit.date }}</td>
            <td>{{ visit.place }}</td>
            <td>{{ visit.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

          <!-- Value Added Courses -->
          <ng-container *ngSwitchCase="'tab10'">
            <section class="content-card">
              <div class="section-head">
                <h3>Value Added Courses</h3>
                <p>Value added course details will be updated soon.</p>
              </div>
            </section>
          </ng-container>

         
     <!-- Alumni -->
<ng-container *ngSwitchCase="'tab11'">
  <section class="content-card">
    <div class="section-head">
      <h3>Alumni</h3>
      <p>Notable alumni of the Department of Master of Business Administration.</p>
    </div>

    <ng-container *ngIf="alumniRecords.length > 0; else noAlumniData">
      <div class="alumni-grid">
        <article class="alumni-card" *ngFor="let alumni of alumniRecords">
          <div class="alumni-photo-wrap">
            <img [src]="alumni.image" [alt]="alumni.name" class="alumni-photo" />
          </div>

          <div class="alumni-content">
            <h4>{{ alumni.name }}</h4>
            <p><strong>Batch:</strong> {{ alumni.batch }}</p>
            <p><strong>Designation:</strong> {{ alumni.designation }}</p>
            <p><strong>Company:</strong> {{ alumni.company }}</p>
          </div>
        </article>
      </div>
    </ng-container>

    <ng-template #noAlumniData>
      <div class="section-copy">
        <p>Alumni details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>

          <!-- Achievements -->
          <ng-container *ngSwitchCase="'tab12'">
            <section class="content-card">
              <div class="section-head">
                <h3>Achievements</h3>
                <p>Achievement details will be updated soon.</p>
              </div>
            </section>
          </ng-container>

          <!-- NPTEL -->
          <ng-container *ngSwitchCase="'tab13'">
            <section class="content-card">
              <div class="section-head">
                <h3>NPTEL</h3>
                <p>NPTEL details will be updated soon.</p>
              </div>
            </section>
          </ng-container>

          <!-- Research -->
          <ng-container *ngSwitchCase="'tab15'">
            <section class="content-card">
              <div class="section-head">
                <h3>Journal Publications</h3>
                <p>Research contributions published by the faculty members of the department.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Title</th>
                      <th>Author(s)</th>
                      <th>Journal Name</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of journalPublications">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.authors.join(', ') }}</td>
                      <td>{{ item.journalName }}</td>
                      <td>{{ item.details }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Conference Publications</h3>
                <p>Papers presented by the department faculty in national and international conferences.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Paper Title</th>
                      <th>Author(s)</th>
                      <th>Conference</th>
                      <th>Organization</th>
                      <th>Date</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of conferenceRecords">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.authors.join(', ') }}</td>
                      <td>{{ item.conferenceName }}</td>
                      <td>{{ item.organization }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.details }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Books Authored</h3>
                <p>Books authored by the faculty members of the department.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Author</th>
                      <th>Book Title</th>
                      <th>Publisher</th>
                      <th>ISBN</th>
                      <th>Published On</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let book of booksAuthored">
                      <td>{{ book.sno }}</td>
                      <td>{{ book.author }}</td>
                      <td>{{ book.title }}</td>
                      <td>{{ book.publisher }}</td>
                      <td>{{ book.isbn }}</td>
                      <td>{{ book.publishedOn }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Default -->
          <ng-container *ngSwitchDefault>
            <section class="content-card">
              <div class="section-head">
                <h3>{{ activeTabLabel }}</h3>
                <p>Content will be updated soon.</p>
              </div>
            </section>
          </ng-container>
        </ng-container>
      </main>
    </section>

    <br />

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Contact</span>
        <h3>Department Contact</h3>
        <p>
          Director,<br />
          Department of Master of Business Administration,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" href="mailto:directormba@fmcet.ac.in">
          {{ contactEmail }}
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Admissions</span>
        <h3>Welcome to Department of Master of Business Administration</h3>
        <p>Build your future in leadership, management, entrepreneurship, and strategic decision-making.</p>
        <a
          href="https://fmcet.ac.in/enquiry/enquiry.html"
          target="_blank"
          rel="noopener"
          class="apply-button"
        >
          Apply Now
        </a>
      </article>
    </section>
  </div>
</div>